var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7658 5.42963H4.43799C3.30471 5.42963 2.33334 6.40101 2.33334 7.61523V22.8335C2.33334 24.0477 3.22376 25.0191 4.43799 25.0191H19.8181C20.9514 25.0191 21.9228 24.0477 21.9228 22.8335V9.80083",
    stroke: "#464646",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4233 18.0575L9.4568 19.1908C8.97111 19.3527 8.56637 18.867 8.72827 18.4622L9.86154 14.5767C9.94249 14.3339 10.0234 14.091 10.2663 13.9291L21.4371 2.75829C22.0038 2.19165 22.8133 2.19165 23.3799 2.75829L25.2417 4.6201C25.8083 5.18673 25.8083 5.99622 25.2417 6.56285L14.0708 17.6528C13.9089 17.8956 13.6661 17.9766 13.4233 18.0575Z",
    stroke: "#464646",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.722470916cd781cbc1706c70a45864c7.svg";
export { ForwardRef as ReactComponent };